/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon20Regular = forwardRef('AttachLinkIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M.25 10A5.75 5.75 0 0 1 6 4.25h1.75a.75.75 0 0 1 0 1.5H6a4.25 4.25 0 0 0 0 8.5h1.75a.75.75 0 0 1 0 1.5H6A5.75 5.75 0 0 1 .25 10Z" }),
        React.createElement("path", { d: "M19.75 10A5.75 5.75 0 0 0 14 4.25h-1.75a.75.75 0 0 0 0 1.5H14a4.25 4.25 0 0 1 0 8.5h-1.75a.75.75 0 0 0 0 1.5H14A5.75 5.75 0 0 0 19.75 10Z" }),
        React.createElement("path", { d: "M6 9.25a.75.75 0 0 0 0 1.5h8a.75.75 0 0 0 0-1.5H6Z" })));
});
